export default __webpack_public_path__ + "static/media/team-members.5cef32f0.jpg";